module.exports = __webpack_public_path__ + "site/img/avatar_default_male.24657e00.png";